import {css} from "@panda/css";

import {BrandSkyscrapersIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {InquiryButtonTypeName} from "../../../../../constants/inquiry_button_type";
import {OfferDisplayType} from "../../../../offer/helpers/OfferDisplayType";
import {useAppDispatch, useAppSelector} from "../../../../store/hooks";
import {VendorDetailActiveOffersPageSize} from "../../../constants/VendorDetailActiveOffersPageSize";
import {VendorDetailSoldOffersPageSize} from "../../../constants/VendorDetailSoldOffersPageSize";
import {setActiveOffersNextPage, setSoldOffersNextPage} from "../../../state/vendor_offer_list_slice";
import {IVendorDetail} from "../../../types/IVendorDetail";
import {VendorDetailReportModalOffersTable} from "./VendorDetailReportModalOffersTable";

interface IProps {
    vendor: IVendorDetail;
    type: OfferDisplayType.FOR_SALE | OfferDisplayType.SOLD;
    header: string;
}

export const VendorDetailReportModalContentOffersTable = (props: IProps) => {
    const {vendor, type, header} = props;
    const dispatch = useAppDispatch();
    const soldOffersPage = useAppSelector((state) => state.vendorDetailViewSlice.soldOffersListParams.page);
    const activeOffersPage = useAppSelector((state) => state.vendorDetailViewSlice.activeOffersListParams.page);

    const currentPage = type === OfferDisplayType.SOLD ? soldOffersPage : activeOffersPage;
    const offersCount = type === OfferDisplayType.SOLD ? vendor.stats.offers_count_sold : vendor.stats.offers_count_for_sale;
    const pageSize = type === OfferDisplayType.SOLD ? VendorDetailSoldOffersPageSize : VendorDetailActiveOffersPageSize;
    const availablePages = Math.ceil(offersCount / pageSize);

    const handleShowMoreClick = () => {
        if (type === OfferDisplayType.SOLD) {
            dispatch(setSoldOffersNextPage());
        } else {
            dispatch(setActiveOffersNextPage());
        }
    };

    return (
        <div className={subHeaderContainerStyle}>
            <div className={subHeaderStyle}>
                <BrandSkyscrapersIcon size="3" />
                <Text variant="mini_header">
                    {header} ({offersCount})
                </Text>
            </div>
            <div className={tableStyle}>
                <VendorDetailReportModalOffersTable vendor={vendor} offersType={type} />
            </div>
            {availablePages > currentPage && (
                <Text variant="body_copy_1" className={showMore} onClick={handleShowMoreClick}>
                    {InquiryButtonTypeName.SHOW_MORE}
                </Text>
            )}
        </div>
    );
};

const subHeaderStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 3,
    mb: 4
});

const subHeaderContainerStyle = css({
    mb: 6,

    md: {
        mb: 10
    }
});

const showMore = css({
    textDecoration: "underline",
    cursor: "pointer",
    mt: 2,
    ml: 2
});

const tableStyle = css({
    overflowX: "scroll",

    md: {
        overflowX: "auto"
    }
});
import {css} from "@panda/css";

import {BrandSkyscrapersIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {InquiryButtonTypeName} from "../../../../../constants/inquiry_button_type";
import {OfferDisplayType} from "../../../../offer/helpers/OfferDisplayType";
import {useAppDispatch, useAppSelector} from "../../../../store/hooks";
import {VendorDetailActiveOffersPageSize} from "../../../constants/VendorDetailActiveOffersPageSize";
import {VendorDetailSoldOffersPageSize} from "../../../constants/VendorDetailSoldOffersPageSize";
import {setActiveOffersNextPage, setSoldOffersNextPage} from "../../../state/vendor_offer_list_slice";
import {IVendorDetail} from "../../../types/IVendorDetail";
import {VendorDetailReportModalOffersTable} from "./VendorDetailReportModalOffersTable";

interface IProps {
    vendor: IVendorDetail;
    type: OfferDisplayType.FOR_SALE | OfferDisplayType.SOLD;
    header: string;
}

export const VendorDetailReportModalContentOffersTable = (props: IProps) => {
    const {vendor, type, header} = props;
    const dispatch = useAppDispatch();
    const soldOffersPage = useAppSelector((state) => state.vendorDetailViewSlice.soldOffersListParams.page);
    const activeOffersPage = useAppSelector((state) => state.vendorDetailViewSlice.activeOffersListParams.page);

    const currentPage = type === OfferDisplayType.SOLD ? soldOffersPage : activeOffersPage;
    const offersCount = type === OfferDisplayType.SOLD ? vendor.stats.offers_count_sold : vendor.stats.offers_count_for_sale;
    const pageSize = type === OfferDisplayType.SOLD ? VendorDetailSoldOffersPageSize : VendorDetailActiveOffersPageSize;
    const availablePages = Math.ceil(offersCount / pageSize);

    const handleShowMoreClick = () => {
        if (type === OfferDisplayType.SOLD) {
            dispatch(setSoldOffersNextPage());
        } else {
            dispatch(setActiveOffersNextPage());
        }
    };

    return (
        <div className={subHeaderContainerStyle}>
            <div className={subHeaderStyle}>
                <BrandSkyscrapersIcon size="3" />
                <Text variant="mini_header">
                    {header} ({offersCount})
                </Text>
            </div>
            <div className={tableStyle}>
                <VendorDetailReportModalOffersTable vendor={vendor} offersType={type} />
            </div>
            {availablePages > currentPage && (
                <Text variant="body_copy_1" className={showMore} onClick={handleShowMoreClick}>
                    {InquiryButtonTypeName.SHOW_MORE}
                </Text>
            )}
        </div>
    );
};

const subHeaderStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 3,
    mb: 4
});

const subHeaderContainerStyle = css({
    mb: 6,

    md: {
        mb: 10
    }
});

const showMore = css({
    textDecoration: "underline",
    cursor: "pointer",
    mt: 2,
    ml: 2
});

const tableStyle = css({
    overflowX: "scroll",

    md: {
        overflowX: "auto"
    }
});
